"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const fs = __importStar(require("fs"));
const path = __importStar(require("path"));
const stateHelper = __importStar(require("./state-helper"));
const core = __importStar(require("@actions/core"));
const actionsToolkit = __importStar(require("@docker/actions-toolkit"));
const context_1 = require("@docker/actions-toolkit/lib/context");
const docker_1 = require("@docker/actions-toolkit/lib/docker/docker");
const exec_1 = require("@docker/actions-toolkit/lib/exec");
const github_1 = require("@docker/actions-toolkit/lib/github");
const inputs_1 = require("@docker/actions-toolkit/lib/buildx/inputs");
const toolkit_1 = require("@docker/actions-toolkit/lib/toolkit");
const context = __importStar(require("./context"));
actionsToolkit.run(
// main
() => __awaiter(void 0, void 0, void 0, function* () {
    const inputs = yield context.getInputs();
    const toolkit = new toolkit_1.Toolkit();
    yield core.group(`GitHub Actions runtime token ACs`, () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield github_1.GitHub.printActionsRuntimeTokenACs();
        }
        catch (e) {
            core.warning(e.message);
        }
    }));
    yield core.group(`Docker info`, () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield docker_1.Docker.printVersion();
            yield docker_1.Docker.printInfo();
        }
        catch (e) {
            core.info(e.message);
        }
    }));
    yield core.group(`Proxy configuration`, () => __awaiter(void 0, void 0, void 0, function* () {
        let dockerConfig;
        let dockerConfigMalformed = false;
        try {
            dockerConfig = yield docker_1.Docker.configFile();
        }
        catch (e) {
            dockerConfigMalformed = true;
            core.warning(`Unable to parse config file ${path.join(docker_1.Docker.configDir, 'config.json')}: ${e}`);
        }
        if (dockerConfig && dockerConfig.proxies) {
            for (const host in dockerConfig.proxies) {
                let prefix = '';
                if (dockerConfig.proxies.length > 1) {
                    prefix = '  ';
                    core.info(host);
                }
                for (const key in dockerConfig.proxies[host]) {
                    core.info(`${prefix}${key}: ${dockerConfig.proxies[host][key]}`);
                }
            }
        }
        else if (!dockerConfigMalformed) {
            core.info('No proxy configuration found');
        }
    }));
    if (!(yield toolkit.buildx.isAvailable())) {
        core.setFailed(`Docker buildx is required. See https://github.com/docker/setup-buildx-action to set up buildx.`);
        return;
    }
    stateHelper.setTmpDir(context_1.Context.tmpDir());
    yield core.group(`Buildx version`, () => __awaiter(void 0, void 0, void 0, function* () {
        yield toolkit.buildx.printVersion();
    }));
    const args = yield context.getArgs(inputs, toolkit);
    const buildCmd = yield toolkit.buildx.getCommand(args);
    yield exec_1.Exec.getExecOutput(buildCmd.command, buildCmd.args, {
        ignoreReturnCode: true
    }).then(res => {
        var _a, _b, _c;
        if (res.stderr.length > 0 && res.exitCode != 0) {
            throw new Error(`buildx failed with: ${(_c = (_b = (_a = res.stderr.match(/(.*)\s*$/)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : 'unknown error'}`);
        }
    });
    const imageID = inputs_1.Inputs.resolveBuildImageID();
    const metadata = inputs_1.Inputs.resolveBuildMetadata();
    const digest = inputs_1.Inputs.resolveDigest();
    if (imageID) {
        yield core.group(`ImageID`, () => __awaiter(void 0, void 0, void 0, function* () {
            core.info(imageID);
            core.setOutput('imageid', imageID);
        }));
    }
    if (digest) {
        yield core.group(`Digest`, () => __awaiter(void 0, void 0, void 0, function* () {
            core.info(digest);
            core.setOutput('digest', digest);
        }));
    }
    if (metadata) {
        yield core.group(`Metadata`, () => __awaiter(void 0, void 0, void 0, function* () {
            core.info(metadata);
            core.setOutput('metadata', metadata);
        }));
    }
}), 
// post
() => __awaiter(void 0, void 0, void 0, function* () {
    if (stateHelper.tmpDir.length > 0) {
        yield core.group(`Removing temp folder ${stateHelper.tmpDir}`, () => __awaiter(void 0, void 0, void 0, function* () {
            fs.rmSync(stateHelper.tmpDir, { recursive: true });
        }));
    }
}));
